import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeProject } from '../../../types/uncinc_profile/nodes';

interface ViewProjectRelatedProps {
  entities: Immutable.List<ImmutableEntity<NodeProject>>;
}

const ViewProjectRelated: React.FC<ViewProjectRelatedProps> = ({ entities }) => {
  const { t } = useTranslation();

  return (
    <div className="ViewProjectRelated">
      {entities.size > 0 && (
        <div className="RelatedContentView">
          <div className="row">
            <div className="col-12">
              <h2>{t('content_types.project.title')}</h2>
            </div>
          </div>
          <div className="row">
            {entities.map((entity) => {
              const Project = entity.toJS();
              const id = Project.nid[0].value;
              const uuid = Project.uuid[0].value;
              const langcode = Project.langcode[0].value;
              const key = `${uuid}:${langcode}`;

              return (
                <Node
                  key={key}
                  id={id}
                  entity={entity}
                  viewMode="teaser"
                  classes="col-12 col-md-6 col-lg-4"
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewProjectRelated;
